var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React from 'react';
import { observer } from 'mobx-react';
import styles from './ws-form.module.scss';
let WSForm = class WSForm extends React.Component {
    constructor(props) {
        super(props);
        this.onConnect = this.onConnect.bind(this);
    }
    setString(name) {
        return (e) => {
            const { store } = this.props;
            store[name] = e.target.value;
        };
    }
    setNumber(name) {
        return (e) => {
            const { store } = this.props;
            store[name] = parseInt(e.target.value, 10);
        };
    }
    setBoolean(name) {
        return (e) => {
            const { store } = this.props;
            store[name] = e.target.checked;
        };
    }
    onConnect(e) {
        const { store } = this.props;
        store.configure();
    }
    render() {
        const { store } = this.props;
        const { hostname, port, path, secured } = store;
        return (React.createElement("div", { className: styles.root },
            React.createElement("div", { className: styles.wsForm },
                React.createElement("div", { className: styles.inputGroup },
                    React.createElement("label", { htmlFor: "hostname" }, "Hostname"),
                    React.createElement("input", { name: "hostname", type: "text", value: hostname, onChange: this.setString('hostname') })),
                React.createElement("div", { className: styles.inputGroup },
                    React.createElement("label", { htmlFor: "port" }, "Port"),
                    React.createElement("input", { name: "port", type: "number", value: port, onChange: this.setNumber('port') })),
                React.createElement("div", { className: styles.inputGroup },
                    React.createElement("label", { htmlFor: "path" }, "Path"),
                    React.createElement("input", { name: "path", type: "text", value: path, onChange: this.setString('path') })),
                React.createElement("div", { className: styles.inputGroup },
                    React.createElement("label", { htmlFor: "secured" }, "Secured"),
                    React.createElement("div", null,
                        React.createElement("input", { name: "secured", type: "checkbox", checked: secured, onChange: this.setBoolean('secured') }))),
                React.createElement("div", { className: styles.inputGroup },
                    React.createElement("label", null),
                    React.createElement("div", null,
                        React.createElement("button", { onClick: this.onConnect }, "Connect"))))));
    }
};
WSForm = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], WSForm);
export default WSForm;
